<template>
  <v-card class="k-card k-group-card pa-3" elevation="2">
    <!-- Header -->
    <div class="d-flex align-center">
      <div class="min-w-0">
        <div class="text-subtitle-1 font-weight-bold text-truncate">
          {{ group.name }}
        </div>
      </div>

      <v-spacer />

      <v-btn
        small
        outlined
        color="primary"
        class="ml-2"
        @click="$emit('invite', group.id)"
      >
        <v-icon left small>mdi-share-variant</v-icon>
        {{ $t("common.invite") }}
      </v-btn>

      <!-- ✅ Salir (solo si NO es admin) -->
      <v-btn
        v-if="!canDelete"
        small
        outlined
        color="error"
        class="ml-2"
        @click="$emit('leave', group.id)"
      >
        <v-icon left small>mdi-logout</v-icon>
        {{ $t("common.leave") }}
      </v-btn>

      <!-- ✅ Eliminar (solo si tiene permiso) -->
      <v-btn
        v-if="canDelete"
        small
        outlined
        color="error"
        class="ml-2"
        @click="$emit('delete', group.id)"
      >
        <v-icon left small>mdi-delete</v-icon>
        {{ $t("common.delete") }}
      </v-btn>
    </div>

    <!-- Miembros (dentro del card) -->
    <div class="k-members mt-3 pa-2">
      <div v-if="!hasMembers" class="text-caption" style="opacity:.6">
        {{ $t("groups.noMembers") }}
      </div>

      <v-chip-group v-else column class="k-chip-group">
        <v-chip
          v-for="m in previewMembers"
          :key="m.userId"
          small
          class="mr-1 mb-1"
          outlined
        >
          {{ displayName(m) }}
          <span v-if="m.role === 'admin'" style="opacity:.7"> · {{ $t("common.admin") }}</span>
        </v-chip>

        <v-chip v-if="extraCount > 0" small class="mr-1 mb-1" outlined>
          +{{ extraCount }}
        </v-chip>
      </v-chip-group>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    group: { type: Object, required: true },
    previewLimit: { type: Number, default: 6 },

    // ✅ permiso para mostrar "Eliminar" (admin)
    canDelete: { type: Boolean, default: false }
  },
  computed: {
    hasMembers() {
      return !!(this.group && this.group.members && this.group.members.length);
    },
    memberCount() {
      return this.hasMembers ? this.group.members.length : 0;
    },
    previewMembers() {
      return this.hasMembers ? this.group.members.slice(0, this.previewLimit) : [];
    },
    extraCount() {
      return this.hasMembers ? Math.max(0, this.group.members.length - this.previewLimit) : 0;
    }
  },
  methods: {
    displayName(m) {
      return m?.profile?.displayName ? m.profile.displayName : this.$t("common.user");
    }
  }
};
</script>

<style scoped>
.k-group-card {
  border-radius: 16px;
}

.k-members {
  border-radius: 14px;
  background: rgba(0, 0, 0, 0.03);
}

.k-chip-group {
  max-width: 100%;
}
</style>
